module.exports = __webpack_public_path__ + "img/favicon-128.b171221d.png";